import React from "react";

export default function SectionHeading({ tag, title, subtitle, align = "center", dark = false }) {
  const alignment = align === "center" ? "text-center" : "text-left";
  return (
    <div className={`${alignment} mb-8 lg:mb-10`}>
      {tag && (
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">{tag}</div>
      )}
      <h2 className={`font-heading text-[clamp(32px,4vw,46px)] font-[650] leading-[1.06] mb-5 ${dark ? "text-white" : "text-heading-gradient"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-[16px] leading-relaxed max-w-[480px] mx-auto ${dark ? "text-[#b7b3cc]" : "text-[#6c6c74]"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}